export default __webpack_public_path__ + "static/media/help-rav-inv-5.553e57c7.png";